import { SxProps, Theme } from '@mui/material';

export const sxStyles: Record<string, SxProps<Theme>> = {
  fab: {
    boxShadow: 'none',
    padding: '0 20px 0 20px',
  },
};
